import React, { useState } from 'react'
import PropTypes, { InferProps } from 'prop-types'
import styled from 'styled-components'
import { Flex, Text } from 'pcln-design-system'
import fetch from 'isomorphic-unfetch'
import { CONTENT, VP_ANALYTICS } from './signup-content'
import EmailSignUpForm from './EmailSignUpForm'
import analytics from '../../utils/analytics'

const EmailContainer = styled(Flex)`
  border-bottom: solid 1px #bfbfbf;
  text-align: center;
`

export default function EmailSignUp({
  category
}: InferProps<typeof EmailSignUp.propTypes>) {
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)

  const submitEmail = ({ signUpEmail }: { signUpEmail: string }): void => {
    setIsLoading(true)
    const URL = `/landing/email_signup.do?INIT_SESSION=true&email=${signUpEmail}&source=${VP_ANALYTICS.uniqueId}`
    fetch(URL)
      .then(res => {
        setIsLoading(false)
        if (res.ok) {
          setSuccess(true)
          analytics.fireEvent({
            action: 'Email Confirm',
            category,
            event: 'gtm-pageload-event',
            label: 'Thank You'
          })
        } else {
          throw Error(res.statusText)
        }
      })
      .catch(err => {
        setError(err)
        setIsLoading(false)
      })
  }

  return (
    <EmailContainer color="background.lightest" mb={0} justifyContent="center">
      {success ? (
        <Text fontSize={3} fontWeight="bold" my={1} py={3} textAlign="center">
          {CONTENT.successMessage}
        </Text>
      ) : (
        <EmailSignUpForm
          category={category}
          error={error}
          isLoading={isLoading}
          submitEmail={submitEmail}
        />
      )}
    </EmailContainer>
  )
}

EmailSignUp.propTypes = {
  category: PropTypes.string.isRequired
}
